module.exports = __webpack_public_path__ + "static/bottle-1459c2c5ed5099eb1a8721e87cd01299.png";